<template>
  <div
    class="Fuell-Table--row"
  >
    <div class="Fuell-Table--item clickable" @click="openReviewFlow" >{{reviewFlow.name}}</div>
    <div class="Fuell-Table--item clickable" @click="openReviewFlow" >{{reviewFlow.steps.length}}</div>
    <div class="Fuell-Table--item clickable" @click="openReviewFlow" >{{budgets}}</div>
    <div class="Fuell-Table--item Fuell-Table--options">
      <dropdown
            :closeOnClickInside="false"

      >
        <div
          class="clickable"
          role="button"
          @click="openReviewFlow"
        >{{$t('ACTION_EDIT')}}</div>
        <div
          class="clickable"
          role="button"
          @click="handleDeleteReviewFlow"
        >{{$t('ACTION_REMOVE')}}</div>

      </dropdown>
    </div>
    <confirm-modal
     v-if="showConfirmDeleteModalFlag"
     :open.sync="showConfirmDeleteModalFlag"
     @accept="deleteReviewFlow"
     :title="'ACTION_REMOVE'"
     :acceptText="'ACTION_REMOVE'"

     ></confirm-modal>
  </div>
</template>

<script>
import Dropdown from '@/components/Commons/Dropdown'
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')
export default {
  name: 'FunnelAprovalFlowsTableRow',
  components: { Dropdown, ConfirmModal },
  props: {
    reviewFlow: {
      type: Object
    }
  },
  data () {
    return {
      showConfirmDeleteModalFlag: false
          }
  },
  computed: {
    budgets () {
      return this.reviewFlow.flowBudgets.map(el => el.budget.name).join(', ')
    }
  },
  methods: {
    openReviewFlow () {
      this.$emit('openReviewFunnelDetail', this.reviewFlow)
    },
    handleDeleteReviewFlow () {
      this.showConfirmDeleteModalFlag = true
    },
    deleteReviewFlow () {
      this.$store.dispatch('CompanyStore/TransactionFieldsStore/deleteReviewFlow', this.reviewFlow.id)
    }
  }

}
</script>

<style>
</style>
